export const CONTRACT_ADDRESSES = {
  ARTBLOCKS_V0: "0x059edd72cd353df5106d2b9cc5ab83a52287ac3a", // Projects 0-2
  ARTBLOCKS_V1: "0xa7d8d9ef8d8ce8992df33d8b8cf4aebabd5bd270", // Projects 3-373
  ARTBLOCKS_V3: "0x99a9b7c1116f9ceeb1652de04d5969cce509b069", // Projects 374+
};

export const CHAIN_IDS = {
  GOERLI: 5,
  MAINNET: 1,
  HARDHAT: 31337,
};

export const SORT_OPTIONS = {
  COLLECTION_ID_ASC: "Sort by Collection Id, ASC",
  COLLECTION_ID_DESC: "Sort by Collection Id, DESC",
  COLLECTION_NAME_ASC: "Sort by Collection Name, ASC",
  COLLECTION_NAME_DESC: "Sort by Collection Name, DESC",
  ARTIST_NAME_ASC: "Sort by Artist Name, ASC",
  ARTIST_NAME_DESC: "Sort by Artist Name, DESC",
};

export const STATUS_FILTERS = {
  ALL: "All",
  COMPLETED: "Completed",
  UPCOMING: "Upcoming",
  OPEN: "Open",
  PAUSED: "Paused",
};

